import { fields, ICrop } from "../../omnia";

import m = omnia.models;

export class CropVM {

    constructor(private crop: ICrop) {

    }

    get name(): string {
        return this.crop.Name;
    }

    get id(): number {
        return this.crop.CropId;
    }

    getCropCssColor(): any {
        return fields.getCropCssColor(this.crop);
    }

}
